import { Template } from "../models/basic/template";
import { AbstractService, Filters } from "./abstract-service";
import { URLS } from "./app-urls";

export type NpiTemplateFilter = Filters & {
    search: string;
};

export class NpiTemplateService extends AbstractService<Template> {

    constructor() {
        super(URLS.TEMPLATE);
    }
}
